import React from "react";
import MaterialIcon from "./MaterialIcon";

const ChipList = ({
  chips = [],
  removeChip,
  containerClassName = "",
  chipClassName = "small_chip",
  labelKey = ["name"],
  delimiter = ", "
}) => {
  const getChipLabel = (chip) => {
    if (typeof chip === "string") {
      return chip;
    }
    if (typeof chip === "object" && chip !== null) {
      if (Array.isArray(labelKey)) {
        return labelKey
          .map((key) => chip[key])
          .filter(Boolean)
          .join(delimiter);
      }
      return chip[labelKey];
    }
    return "";
  };

  return (
    <div className={`chip_wrapper ${containerClassName}`}>
      {chips.map((chip, index) => (
        <span key={index} className={`single_chip ${chipClassName}`}>
          <span>{getChipLabel(chip)}</span>
          {removeChip && (
            <MaterialIcon
              name="close"
              className="font_size_small remove_chip cursor_pointer"
              onClick={(e) => removeChip(chip, index, e)}
            />
          )}
        </span>
      ))}
    </div>
  );
};

export default ChipList;
